import { Heading, Button, Copy } from '@sparemin/blockhead';
import React, { useEffect, useRef } from 'react';
import styles from './CopyUrlDisplay.module.scss';

export interface CopyUrlDisplayProps {
  onPress: () => void;
  url: string;
}

const CopyUrlDisplay: React.FC<CopyUrlDisplayProps> = ({ url, onPress }) => {
  const buttonRef = useRef<HTMLButtonElement>(null);

  // https://github.com/adobe/react-spectrum/issues/1513#issuecomment-1641830053
  useEffect(() => {
    buttonRef.current?.addEventListener(
      'touchend',
      (e) => {
        e.preventDefault();
      },
      { passive: false, once: true },
    );
  }, []);

  return (
    <div className={styles.root}>
      <div className={styles.plate}>
        <Heading level={2} className={styles.heading}>
          {url}
        </Heading>
        <div className={styles.buttonContainer}>
          <Button
            ref={buttonRef}
            size="small"
            startIcon={<Copy width="11px" height="12px" />}
            onPress={() => onPress()}
          >
            copy
          </Button>
        </div>
      </div>
    </div>
  );
};
export default CopyUrlDisplay;
